<script lang="ts">
    import { sendEmail } from "../../api"

    let formData: {
        firstname: string
        lastname: string
        email: string
        subject: string
        message: string
    } = {
        firstname: "",
        lastname: "",
        email: "",
        subject: "",
        message: "",
    }
    let requestSucessfully = false
    let requestLoading = false

    const submit = () => {
        if (
            formData["firstname"] !== "" ||
            formData["lastname"] !== "" ||
            formData["email"] !== "" ||
            formData["message"] !== ""
        ) {
            requestLoading = true
            sendEmail("contactForm", formData)
                .then(() => {
                    resetForm()
                    requestSucessfully = true
                    requestLoading = false
                })
                .catch((e) => {
                    console.error(e)
                    requestLoading = false
                })
                .finally(() => {
                    requestLoading = false
                })
        }
    }

    const resetForm = () => {
        formData = {
            firstname: "",
            lastname: "",
            email: "",
            subject: "",
            message: "",
        }
    }
</script>

<h1>Kontakt</h1>

{#if requestSucessfully}
    <div class="mt-lg">
        <h2 class="mb-md">Vielen Dank für Ihre Kontaktaufnahme!</h2>
        Ich werde mich zeitnah mit Ihnen in Verbindung setzen!
    </div>
{:else}
    <form on:submit|preventDefault="{submit}" class="mt-lg">
        <div class="layout layout-gap-md">
            <input
                type="text"
                bind:value="{formData['firstname']}"
                placeholder="Vorname"
                readonly="{requestLoading}"
            />
            <input
                type="text"
                bind:value="{formData['lastname']}"
                placeholder="Nachname"
                readonly="{requestLoading}"
            />
        </div>
        <div class="layout mt-md">
            <input
                type="text"
                bind:value="{formData['email']}"
                placeholder="E-Mail Adresse"
                readonly="{requestLoading}"
            />
        </div>
        <div class="layout mt-md">
            <input
                type="text"
                bind:value="{formData['subject']}"
                placeholder="Betreff"
                readonly="{requestLoading}"
            />
        </div>
        <div class="layout mt-md">
            <textarea
                bind:value="{formData['message']}"
                readonly="{requestLoading}"></textarea>
        </div>
        <div class="layout justify-content-end mt-md">
            <button type="submit" disabled="{requestLoading}"
                >Ihre Nachricht Senden</button
            >
        </div>
    </form>
{/if}
